import {otto} from "@otto-ec/global-resources/nexus";
import {TopicPromoNew} from "./topicpromo_new";
import {PromoTopicPromo} from "./topicpromo";
import {Logger} from "./logger";

otto.ft3.promo.topicpromo.assignNamespace({
    init,
    init_new: TopicPromoNew.init
});

function init(): void {
    Logger.group("[FT3 promo topicpromo]");
    Logger.count("Topicpromo Invocation");
    const containers = document.querySelectorAll('.promo_topicpromo--container');

    containers.forEach((container: Element) => {
        if (container.getAttribute("data-tracked") !== "true") {
            container.setAttribute("data-tracked", "true");
            new PromoTopicPromo(container);
        }
    });

    Logger.groupEnd();
}